import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-2" }, "Medication", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Condition "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Prescriber "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Precribed On ")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "ma-2",
    "min-width": "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_card, {
            elevation: 4,
            class: "rounded-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_table, {
                    "fixed-header": "",
                    height: "300px"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medications, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.name
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.condition), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, _toDisplayString(item.name), 1)
                              ]),
                              _createTextVNode(),
                              _hoisted_3,
                              _createElementVNode("span", null, _toDisplayString(item.dose), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.prescriber), 1),
                            _createElementVNode("td", null, _toDisplayString(item.prescribedOn), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}